<bootstrap-popup [id]="'viewMessageDialog'" [title]="'Message collationn&eacute;'" [displaySubject]="displaySubject">
	<div class="row" *ngIf="message">
		<div class="col-md-6">
			<div class="panel panel-default">
				<div class="panel-heading">
					<h3>Agent</h3>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">Nom&nbsp;: </label>
							{{ message.agentNom }}
						</div>
						<div class="col-sm-6">
							<label class="control-label">Pr&eacute;nom&nbsp;: </label>
							{{ message.agentPrenom }}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">Fonction&nbsp;: </label>
							{{ message.agentFonction }}
						</div>
						<div class="col-sm-6">
							<label class="control-label">Entit&eacute;&nbsp;: </label>
							{{ message.agentEntite }}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">N&deg;&nbsp;: </label>
							{{ numeroMessage }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="panel panel-default">
				<div class="panel-heading">
					<h3>Correspondant</h3>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">Nom&nbsp;: </label>
							{{ message.correspondantNom }}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">Fonction&nbsp;: </label>
							{{ message.correspondantFonction }}
						</div>
						 <div class="col-sm-6">
							<label class="control-label">Entit&eacute;&nbsp;: </label>
							{{ message.correspondantEntite }}
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<label class="control-label">N&deg;&nbsp;: </label>
							{{ message.correspondantNum }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12">
			<div class="panel panel-default">
				<div class="panel-heading">
					<h3>Message</h3>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-md-6">
							<label class="control-label">Date&nbsp;: </label>
							{{ message.dateMessage | displayLocalTimeWithoutSeconds }}
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<label class="control-label">Parc(s)&nbsp;: </label>
							{{ message.parcNames }}
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<label class="control-label">Objet&nbsp;: </label>
						</div>
						<div class="col-md-12">
							<p class="commentaire">{{ message.message }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button
					type="button"
					class="btn btn-default"
					style="margin-right: 6px"
					(click)="onCancelRequested()"
					>
					Fermer
				</button>
			</div>
		</div>
	</div>
</bootstrap-popup>